import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useState } from 'react';
import { LoginDialog } from './LoginDialog';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function LoginPromptDialog({ open, onOpenChange }: Props) {
  const [loginOpen, setLoginOpen] = useState(false);

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Anmelden, um weiterzumachen</DialogTitle>
            <DialogDescription>
              Um das Innere Team weiter zu nutzen, melde dich bitte kostenlos an.
              Deine bisherigen Entdeckungen und Chats bleiben erhalten.
            </DialogDescription>
          </DialogHeader>
          <div className="flex gap-2 justify-end mt-4">
            <Button variant="outline" onClick={() => onOpenChange(false)}>Später</Button>
            <Button onClick={() => { onOpenChange(false); setLoginOpen(true); }}>
              Jetzt anmelden
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      <LoginDialog open={loginOpen} onOpenChange={setLoginOpen} />
    </>
  );
}
